import axios from "axios";
import Constants from '../constants.ts';
let baseURL = Constants.API_BASE;
export const http = axios.create({
  baseURL: baseURL
});
